import { render, staticRenderFns } from "./scholar-ships.vue?vue&type=template&id=ea09c19a&"
import script from "./scholar-ships.vue?vue&type=script&lang=js&"
export * from "./scholar-ships.vue?vue&type=script&lang=js&"
import style0 from "./scholar-ships.vue?vue&type=style&index=0&id=ea09c19a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports